// TypeScript declarations for i18next
import { resources } from './index';

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'common';
    resources: (typeof resources)['en'];
  }
}

// Supported languages
export const SUPPORTED_LANGUAGES = ['de', 'fr', 'it', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// Language display names
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  en: 'English',
};

// Translation namespaces
export const NAMESPACES = ['common'] as const;
export type Namespace = (typeof NAMESPACES)[number];

// Utility type for translation keys
export type TranslationKey<T = Record<string, unknown>> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? `${K}.${TranslationKey<T[K]>}`
          : K
        : never;
    }[keyof T]
  : never;

// Common translation keys type
export type CommonTranslationKey = TranslationKey<typeof resources.en.common>;

export type TFunction = (
  key: CommonTranslationKey,
  options?: Record<string, unknown>
) => string;
